export default __webpack_public_path__ + "static/media/Pistol_6.08cafd38.png";